import type { Dispatch } from 'react';

export interface AppContextState {
  isMobile: boolean;
  isDark: boolean;
  systemId: string;
  tenantId: string;
  userId: string;
  isPrivate?: boolean;
  isAnonymous?: boolean;
  /** True when the user is a resolved public (unauthenticated) widget user with no userId. */
  isPublicAnonymousUser?: boolean;
}

export enum AppContextActionTypes {
  SET_IS_MOBILE = 'SET_IS_MOBILE',
  SET_IS_DARK = 'SET_IS_DARK',
}

export type AppContextActionsMap = {
  [AppContextActionTypes.SET_IS_MOBILE]: boolean;
  [AppContextActionTypes.SET_IS_DARK]: boolean;
};

export type AppContextActions = {
  [k in keyof AppContextActionsMap]: {
    type: k;
    payload: AppContextActionsMap[k];
  };
}[keyof AppContextActionsMap];

export type AppContextDispatcher = Dispatch<AppContextActions>;
